export default "__VITE_ASSET__DDH$nGWZ__"